import StringMask from 'string-mask';

// local dependencies
import { DATA_TYPES } from 'constants/common';

// mask patterns
const phoneMask = new StringMask( '000-000-0000' );
const dateMask = new StringMask( '00-00-0000' );
const timeMask = new StringMask( '00:00' );

/**
 * @type {function}
 * @desc Mask a string value with a pattern.
 * @example
 * import { maskString } from 'utils/mask';
 * const result = maskString( {} );
 */
export const maskString = ( { value, type = DATA_TYPES.TEXT } = {} ) => {
    switch( type ) {

        // phone number
        case DATA_TYPES.PHONE: {
            return phoneMask.apply( value );
        }

        // date (mm-dd-yyy format)
        case DATA_TYPES.DATE: {
            return dateMask.apply( value );
        }

        // date (mm-dd-yyy format)
        case DATA_TYPES.TIME: {
            return timeMask.apply( value );
        }

        // other
        default: {
            return `${ value }`;
        }
    }
};
